<template>
  <div class="list-container">
    <h1>建物情報一覧</h1>

    <!-- 検索バーの追加 -->
    <div class="search-container p-3 my-3" style="background-color: #f8f9fa;"> <!-- 背景色を薄く設定 -->
      <div class="row g-3 align-items-center">

        <div class="col-auto">
          <label for="searchCustomerName" class="col-form-label">顧客名</label>
        </div>
        <div class="col-auto">
          <select id="searchCustomerName" class="form-select" v-model="searchCustomerName" placeholder="顧客名で検索">
            <option value="" disabled selected>選択してください</option> <!-- placeholder -->
            <option v-for="customer in customers" :key="customer.id" :value="customer.id">{{ customer.customer_nm }}</option>
          </select>
        </div>

        <div class="col-auto">
          <label for="searchBuildingTypeName" class="col-form-label">建物種別</label>
        </div>
        <div class="col-auto">
          <select id="searchBuildingTypeName" class="form-select" v-model="searchBuildingTypeName" placeholder="建物種別で検索">
            <option value="" disabled selected>選択してください</option> <!-- placeholder -->
            <option v-for="buildingType in buildingTypes" :key="buildingType.id" :value="buildingType.id">{{ buildingType.building_type_nm }}</option>
          </select>
        </div>

        <div class="col-auto">
          <label for="searchName" class="col-form-label">建物名</label>
        </div>
        <div class="col-auto">
          <input type="text" id="searchBuildingName" class="form-control" v-model="searchBuildingName" placeholder="建物名で検索">
        </div>

        <div class="col-auto">
          <button class="btn btn-primary mx-1" @click="searchBuildings">検索</button>
          <button class="btn btn-secondary mx-1" @click="searchResetBuildings">クリア</button>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        @change-page="handleChangePage"
      />
    </div>

    <div>
      <table class="table table-bordered">
        <thead class="table-dark">
          <tr>
            <th class="text-nowrap">建物名</th>
            <th class="text-nowrap">区分</th>
            <th class="text-nowrap">顧客名</th>
            <th class="text-nowrap">所在地</th>
            <th class="text-nowrap">電話番号</th>
            <th class="btn-cell"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="building in buildings" :key="building.id">
            <td>{{ building.building_nm }}</td>
            <td class="text-nowrap">{{ building.m_building_type.building_type_nm }}</td>
            <td>{{ building.m_customer.customer_nm }}</td>
            <td>〒{{ building.postal_code }} {{building.prefecture}}{{building.city}}{{building.other_address}}</td>
            <td class="text-nowrap">{{ building.tel_num }}</td>
            <td class="btn-cell text-nowrap">
              <div class="action-buttons">
                <router-link :to="{ name: 'CustomerBuildingReportList', params: { customer_id: building.m_customer.id, building_id: building.id }}"> <!-- 建物情報編集ページへのリンク -->
                  <button type="button" class="btn btn-primary">報告書一覧</button>
                </router-link>

                <router-link :to="{ name: 'CustomerMeasurementReportCreate', params: { customer_id: building.m_customer.id, building_id: building.id }}"> <!-- 建物情報編集ページへのリンク -->
                  <button type="button" class="btn btn-success">報告書作成</button>
                </router-link>

                <!-- IES4取込は管理者・一般・システム管理者に公開（API側でも同条件を検証） -->
                <button
                  v-if="canUseIes4"
                  type="button"
                  class="btn btn-outline-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#measurementReportIes4ImportModal"
                  @click="handleIes4ImportClick(building)"
                >
                  IES4ファイルから報告書を作成
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <!-- IES4取込：対象建物を確定した状態でファイルを選び、取込画面へ引き継ぐ -->
    <div
      class="modal fade"
      id="measurementReportIes4ImportModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">IES4ファイルから報告書を作成</h5>
            <div class="d-flex align-items-center gap-3">
              <!-- 取込を始める前にも操作説明を開けるようにしている -->
              <a class="manual-link" :href="manualUrl" target="_blank" rel="noopener">操作説明（PDF）</a>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
          </div>
          <div class="modal-body">
            <div class="selected-building-box mb-3">
              <div class="label">作成対象の建物</div>
              <div class="fw-bold">{{ selectedIes4Building?.building_nm || '-' }}</div>
              <div class="text-muted small">{{ selectedIes4Building?.m_customer?.customer_nm || '-' }}</div>
            </div>

            <label for="measurementReportIes4File" class="form-label">IES4ファイル</label>
            <input
              id="measurementReportIes4File"
              type="file"
              class="form-control"
              accept=".IES4,.ies4"
              @change="handleIes4FileChange"
            >
            <div class="form-text">
              測定機器が出力したIES4ファイル（拡張子 .IES4）を選択してください。取込画面へ進むと自動で解析します。
            </div>
            <div v-if="ies4FileError" class="alert alert-danger mt-2 mb-0">{{ ies4FileError }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">キャンセル</button>
            <button type="button" class="btn btn-primary" :disabled="!selectedIes4File || !!ies4FileError" @click="handleIes4Create">
              取込画面へ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted, watchEffect } from 'vue';
import { getBuildings, getCustomers, getBuildingTypes } from '@/api/axios';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { Modal } from 'bootstrap';
import Pagination from '@/components/shared/Pagination.vue';
import { filterActiveRecords } from '@/utils/filterActiveRecords';
import { canUseIes4Import, currentRoleFromStoreOrLocalStorage } from '@/utils/roleAuthorization';
import { setPendingIes4File } from '@/utils/pendingIes4File';
import { IES4_IMPORT_MANUAL_URL } from '@/utils/manualLinks';

const IES4_MAX_UPLOAD_SIZE = 10 * 1024 * 1024;

export default {
  components: {
    Pagination
  },
  setup() {
    const store = useStore();
    const title = ref('建物一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const buildings = ref([]);
    const customers = ref([]);
    const buildingTypes = ref([]);
    const selectedIes4Building = ref(null);
    const selectedIes4File = ref(null);
    const ies4FileError = ref('');
    const route = useRoute();
    const isDemoMode = route.query.demo === '1';

    const canUseIes4 = computed(() => (
      isDemoMode || canUseIes4Import(currentRoleFromStoreOrLocalStorage(store.state.userRole))
    ));

    const demoBuildings = [
      {
        id: 101,
        building_nm: '新宿ビル',
        postal_code: '160-0023',
        prefecture: '東京都',
        city: '新宿区',
        other_address: '西新宿1-1-1',
        tel_num: '03-0000-0000',
        m_customer: { id: 201, customer_nm: '金子商事株式会社' },
        m_building_type: { id: 1, building_type_nm: 'テナントビル' }
      },
      {
        id: 102,
        building_nm: 'GINZA gCUBE',
        postal_code: '104-0061',
        prefecture: '東京都',
        city: '中央区',
        other_address: '銀座7-9-5',
        tel_num: '',
        m_customer: { id: 202, customer_nm: '株式会社スペーストラスト　銀座管理センター' },
        m_building_type: { id: 1, building_type_nm: 'テナントビル' }
      },
      {
        id: 103,
        building_nm: 'HOTEL WAKO',
        postal_code: '160-0021',
        prefecture: '東京都',
        city: '新宿区',
        other_address: '歌舞伎町2-35-9',
        tel_num: '',
        m_customer: { id: 203, customer_nm: 'HOTEL WAKO' },
        m_building_type: { id: 2, building_type_nm: 'ホテル' }
      }
    ];

    // 検索用のデータプロパティ
    const searchCustomerName = ref('');
    const searchBuildingName = ref('');
    const searchBuildingTypeName = ref('');

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(20); // トータルページ数を管理するためのプロパティ

    const fetchBuildings = async (page = 1) => {
      if (isDemoMode) {
        buildings.value = demoBuildings;
        customers.value = [{ id: 201, customer_nm: '金子商事株式会社' }];
        buildingTypes.value = [{ id: 1, building_type_nm: 'テナントビル' }, { id: 2, building_type_nm: 'ホテル' }];
        totalPages.value = 1;
        currentPage.value = page;
        return;
      }

      try {
        const response = await getBuildings({
          customer_id: searchCustomerName.value,
          building_type_id: searchBuildingTypeName.value,
          building_nm: searchBuildingName.value,
          page
        });
        buildings.value = response.data.buildings;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
      } catch (error) {
        if (isDemoMode) {
          buildings.value = demoBuildings;
          totalPages.value = 1;
          currentPage.value = 1;
        }
        console.error('建物情報ーデータの取得に失敗しました:', error);
      }

      // 顧客情報（検索用）
      try {
        const response = await getCustomers();
        customers.value = filterActiveRecords(response.data.customers || []);
      } catch (error) {
        if (isDemoMode) {
          customers.value = [{ id: 201, customer_nm: '金子商事株式会社' }];
        }
        console.error('顧客情報ーデータの取得に失敗しました:', error);
      }

      // 建物種別情報（検索用）
      try {
        const response = await getBuildingTypes();
        buildingTypes.value = filterActiveRecords(response.data.building_types || []);
      } catch (error) {
        if (isDemoMode) {
          buildingTypes.value = [{ id: 1, building_type_nm: 'テナントビル' }, { id: 2, building_type_nm: 'ホテル' }];
        }
        console.error('建物種別情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleChangePage = async (page) => {
      if (page < 1 || page > totalPages.value) return;
      await fetchBuildings(page);
    };

    // 建物を検索するメソッド
    const searchBuildings = async () => {
      await fetchBuildings(1);
    };

    // 建物を検索リセットするメソッド
    const searchResetBuildings = async () => {
      searchCustomerName.value = '';
      searchBuildingName.value = '';
      searchBuildingTypeName.value = '';
      await fetchBuildings(1);
    };



    const router = useRouter();


    const handleIes4ImportClick = (building) => {
      selectedIes4Building.value = building;
      selectedIes4File.value = null;
      ies4FileError.value = '';
      const input = document.getElementById('measurementReportIes4File');
      if (input) input.value = '';
    };

    const handleIes4FileChange = (event) => {
      const file = event.target.files?.[0] || null;
      selectedIes4File.value = file;
      ies4FileError.value = '';

      if (!file) return;

      if (!file.name.toLowerCase().endsWith('.ies4')) {
        ies4FileError.value = '拡張子がIES4のファイルを選択してください';
      } else if (file.size > IES4_MAX_UPLOAD_SIZE) {
        ies4FileError.value = 'ファイルサイズは10MB以下にしてください';
      }
    };

    const closeIes4Modal = () => {
      const modalElement = document.getElementById('measurementReportIes4ImportModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    const handleIes4Create = () => {
      if (!selectedIes4Building.value || !selectedIes4File.value || ies4FileError.value) return;

      const building = selectedIes4Building.value;
      // 選択したファイルを取込画面へ引き渡す（取込画面側で自動解析する）
      setPendingIes4File(selectedIes4File.value, building.id);
      closeIes4Modal();
      router.push({
        name: 'MeasurementReportIes4Import',
        params: {
          customer_id: building.m_customer.id,
          building_id: building.id
        },
        query: {
          ...(isDemoMode ? { demo: '1' } : {})
        }
      });
    };


    onMounted(fetchBuildings);

    return {
      title,
      manualUrl: IES4_IMPORT_MANUAL_URL,
      buildings,
      customers,
      buildingTypes,
      canUseIes4,
      searchCustomerName,
      searchBuildingName,
      searchBuildingTypeName,
      currentPage,
      totalPages,
      handleChangePage,
      searchBuildings,
      searchResetBuildings,
      selectedIes4Building,
      selectedIes4File,
      ies4FileError,
      handleIes4ImportClick,
      handleIes4FileChange,
      handleIes4Create
    };
  }
};
</script>

<style scoped>
/* 操作説明PDFへのリンク。画面の主導線ではないため控えめに見せる */
.manual-link {
  font-size: 0.9rem;
  color: #2f4e6d;
  text-decoration: underline;
  white-space: nowrap;
}

.manual-link:hover {
  color: #1b2f42;
}

.list-container {
  padding: 20px 20px 80px 20px;
  margin: auto;
}

.building-item {
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.building-item:hover {
  background-color: #f5f5f5;
}

table .btn-cell{
  width: 640px;
  min-width: 640px;
  max-width: 640px;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.selected-building-box {
  border: 1px solid #d7dee7;
  background: #f8f9fa;
  padding: 12px 14px;
}

.selected-building-box .label {
  color: #6c757d;
  font-size: 13px;
  margin-bottom: 4px;
}
</style>
